<template>
  <div>
    <p class="top-header">
      <router-link :to="{ name: 'super_admin_accounts' }"
        ><v-icon class="cursor--pointer">mdi-reply</v-icon></router-link
      >
      {{ superAdmin.name }}
    </p>
    <v-tabs v-model="tab">
      <v-tab class="text-capitalize"
        ><span class="vlue-tab-span">{{ $t("EditSuperAdmin") }}</span></v-tab
      >
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <EditSuperAdmin :superAdminProp="superAdmin" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import EditSuperAdmin from "./EditSuperAdmin";
import RestResourceAdmin from "../../api/apiAdminService";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default {
  components: { EditSuperAdmin },
  data() {
    return {
      superAdmin: {
        name: ""
      },
      tab: null
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      RestResourceAdmin.prototype
        .getSuperAdmins(this.$route.params.id)
        .then(response => {
          this.superAdmin = response.data;
        })
        .catch(error => {
          throw error;
        });
    }
  }
};
</script>

<style></style>
